
export default function Location() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">位置資訊</h2>
          <p className="text-xl text-gray-600">交通便利，輕鬆抵達</p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 mb-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">地址</h3>
                <p className="text-lg text-gray-700">946台灣屏東縣恆春鎮下泉路49-3號</p>
                <a
                  href="http://maps.google.com/maps?q=946台灣屏東縣恆春鎮下泉路49-3號"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-3 text-teal-600 hover:text-teal-700 font-medium cursor-pointer"
                >
                  <i className="ri-navigation-line"></i>
                  在 Google 地圖中開啟
                </a>
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed/v1/place?q=21.92742200,120.73221400&key=AIzaSyD_pkfhaiGdG1KCausLQB0mgmr_xfgqis0"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="離海5min b&b 位置"
            ></iframe>
          </div>

          <div className="mt-8 grid md:grid-cols-3 gap-6">
            <div className="bg-teal-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-teal-500 rounded-full flex items-center justify-center">
                <i className="ri-car-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">開車前往</h4>
              <p className="text-gray-700">距離海邊僅需3-5分鐘車程</p>
            </div>
            <div className="bg-blue-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-blue-500 rounded-full flex items-center justify-center">
                <i className="ri-parking-box-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">停車方便</h4>
              <p className="text-gray-700">提供免費停車空間</p>
            </div>
            <div className="bg-green-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-green-500 rounded-full flex items-center justify-center">
                <i className="ri-taxi-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">包車服務</h4>
              <p className="text-gray-700">可提供包車接送服務</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
